require('../../modules/es6.string.iterator');
require('../../modules/web.dom.iterable');
module.exports = require('../../modules/_wks-ext').f('iterator');



// WEBPACK FOOTER //
// ./~/babel-runtime/~/core-js/library/fn/symbol/iterator.js